module.exports = __webpack_public_path__ + "static/drainlaying_2-3f28cbef94084941a1a34103f7e12fea.jpg";